import React,{useState,useEffect,useRef} from 'react'
import axios from "axios";
import {APIURL} from "../../../Global";
import {Modal} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import { ToggleButtonGroup } from "react-bootstrap";
import { ClearButton, Typeahead } from "react-bootstrap-typeahead";
import {  Dropdown, ToggleButton, Tab, Tabs,  ButtonGroup } from "react-bootstrap";
import { Spinner } from 'react-bootstrap';


function MedicinePage(props) {

const[pageShow,setPageShow]=useState(true)
const [detailData, setDetailData] = useState([]);

const[pageShow1,setPageShow1]=useState(false)
const SubjectTypeahead = useRef(null)
const [nameError, setNameError] = useState("")
const [selectedItems, setSelectedItems] = useState([]);
const [dataList, setDataList] = useState([])
const [serviceList, SetServiceList] = useState([]);
let placeholder = "Select medicine name"
const [id, setId] = useState("")
const [sub_service, setServiceName] = useState("")
const [vat, setVat] = useState("")
const [discount, setDiscount] = useState("")
//const [doctors, setDoctors] = useState(detailData);
const [amount, setAmount] = useState("")
const [main_service_name, setMainService] = useState("medicine")

let url = ""
let name = ""

 if (pageShow===true) {
    name = "service_name"
    placeholder = "Search medicine"
    url =  "/api/v1/service-provider/hospital-services/?type=master_medicine"
}
else {
    placeholder = "Please Chooce a medicine"

}
const isValid = dataList.filter((option) => !!option[name]).length === dataList.length;

const options = isValid ?  dataList && dataList.map((option) => {
    return {
        label: option[name],
        main_service_name:"medicine",
        //unified_code: option["unified_code"],
        id: option["id"],
        amount:option["amount"],
        vat:option["vat"],
        discount:option["discount"]
    }

}) : [];

useEffect(() => {

    
    const tokenString = sessionStorage.getItem("usertoken");

    let v2 = tokenString.replace(/["]+/g, "");

 axios
      .get(
        `${APIURL}/api/v1/service-provider/careplan-schedule/?patient_id=${props.patientID}&type=medicine`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + v2,
          },
        }
      )
      .then((res) => {
       
          if (res.data.status === "success") {
            const datas = res.data.details;
          
          
           setDetailData(datas);
           // setHasNext(() => res.data.has_next);
         
           // setDisplay1(true);
       
        
        }  
    
      })
      .catch((err) => {
      
      });

}, []);

  // Group the medicines by doctor
  const doctors = detailData.reduce((acc, curr) => {
    

    if (!curr.medicines || curr.medicines.length === 0) {
        return acc;
      }
    
    const doctorName = curr.medicines[0].doctor_name;
    if (!acc[doctorName]) {
      acc[doctorName] = { name: doctorName, medicines: [] };
    }
    acc[doctorName].medicines = acc[doctorName].medicines.concat(
      curr.medicines
    );
    return acc;
  }, {});








const handleItemSelect = (index) => {
    
    if (selectedItems.includes(index)) {
      setSelectedItems(selectedItems.filter((item) => item !== index));
    } else {
      setSelectedItems([...selectedItems, index]);
    }
 
  };
const handleAdd =() =>{

    
    props.dataHandle(serviceList)
    props.modalClose()
}

// const handleRemoveItem = (doctorName, i) => {
//     // find the doctor's medicines array in the groupedDetails object
//     const doctor = groupedDetails[doctorName];
//     const medicines = [...doctor.medicines];
  
//     // remove the medicine at the given index from the new medicines array
//     medicines.splice(i, 1);
  
//     // create a new object that contains the updated medicines array for the doctor
//     const updatedDoctor = {
//       ...doctor,
//       medicines: medicines
//     };
  
//     // create a new object that contains the updated doctor for the groupedDetails object
//     const updatedGroupedDetails = {
//       ...groupedDetails,
//       [doctorName]: updatedDoctor
//     };
  
//     // set the state with the updated object
//     setDetailData(updatedGroupedDetails);
//   };

const handleRemoveItem = idx => {
  // assigning the list to temp variable
  const temp = [...doctors.slice(0, idx), ...doctors.slice(idx + 1)];

  // removing the element using splice
 // temp.splice(idx, 1);

  // updating the list
  setDetailData(temp);
}
const handlePage =()=>
{
    setPageShow(true);
    setPageShow1(false);
}
const handleRegPage =()=>
{
    setPageShow(false);
    setPageShow1(true);
}

const handleMed =() =>{
    
    // create a new array of only the selected details
    const selectedDetails = Object.values(doctors)
      .filter((doctor, index) => selectedItems.includes(index))
      .map((doctor) => ({ doctor_name: doctor.name, medicines:doctor.medicines }));
  


    props.dataMed(selectedDetails)
    props.modalClose()
}



return(

    <div className="paymentconfiginner">

 
        <button className="medicinebuttons1" style={{backgroundColor : pageShow1 ? "#086073" : "#8F8F8F" }}  onClick={()=>handleRegPage(true)}>Prescriptions</button>
        <button className="medicinebuttons2" style={{backgroundColor : pageShow ? "#086073" : "#8F8F8F" }}  onClick={() => handlePage()}>Medicines</button><br/><br/>
       
{pageShow ? 

<div className="" style={{marginRight:"4%",marginTop:"-6%" ,alignItems:"center"}} >
<div style={{ display: "flex", marginTop:"7%", width:"50%" ,marginLeft:"25%"}}>
    
<Typeahead
                            ref={SubjectTypeahead}
                            placeholder={placeholder}
                            style={{width:"100%"}}
                            onFocus={() => {
                                setNameError("")
                                const tokenString = sessionStorage.getItem("usertoken");

                                let v2 = tokenString.replace(
                                    /["]+/g,
                                    ""
                                ); /* REGEX To remove double quotes from tokenstring */
                                
                                if (!url) {
                                    return;
                                }
                                axios
                                    .get(`${APIURL}${url}`, {
                                        headers: { Authorization: "Token " + v2 },
                                    })
                                    .then((res) => {
                                      
                              
                                        if (res.status === 200) {

                                            const datas = res.data;

                                            setDataList(datas);
                                           
                                        }
                                    })
                            }}

                            options={options}
                            onChange={(data) => {
                              
                              
                                if (data.length) {
                                    setServiceName(data[0].label);
                                    //setUnicode(data[0].unified_code);
                                    setId(data[0].id)
                                    setAmount(data[0].amount)
                                    setVat(data[0].vat)
                                    setDiscount(data[0].discount)
                                    // setSerCategory(data[0].service_category)
                                }
                            }
                            }

                        >
                            {({ onClear, selected }) => (
                                <div className="rbt-aux" style={{ width:"5%"}}>
                                    {!!selected.length && <ClearButton onClick={onClear} />}
                                    {!selected.length && <Spinner animation="grow" size="sm" />}
                                </div>
                            )}
                        </Typeahead>
                        <button onClick={() =>{
                            serviceList.filter(value =>
                                value.sub_service === sub_service).length > 0 ?
                                setNameError(sub_service + " already there in your list!") :sub_service&&
                                SetServiceList(prevArray => [...prevArray, { sub_service, id,amount,vat,discount,main_service_name,quantity:"1" }]);
                        }}
                            className="btn btn-primary btn-col search-btn">
                            <i class="fa fa-arrow-right" aria-hidden="true"></i>
                           
                        </button></div>
                        {nameError ? <span className="error-validation-msg" style={{marginTop:"10%", width:"10%",height:"10%",color:"red"}}>{nameError}</span>:null}
                       
               
                    <div className="formField">
                        {serviceList.filter(value => Object.keys(value).length > 0).map((list, idx) => {
                            const value = list.sub_service;
                            return <>
                                <div key={idx} className='list-medicines' style={{ padding: "1px", marginTop: "20px" }}>
                                    <input type="number"
                style={{width: "52px" ,height: "30px", marginLeft:"10%"}}
                value={list.quantity !== undefined ? list.quantity : 1}
                min="1"
               
                onChange={(e) => {
                    const quantity = e.target.value;
                    const updatedList = {...list, quantity};
                    const updatedServiceList = [...serviceList];
                    updatedServiceList[idx] = updatedList;
                    SetServiceList(updatedServiceList);
                }}
                />Qty
                                    <label style={{ color: "#000000" ,marginLeft:"30%",marginTop:"2%" }} className='list-names'><b>{value}</b>  </label>
                                    {/* <i
                                        class="fas fa-trash-alt"
                                        onClick={() => handleRemoveItem(idx)}
                                        style={{ float: "right", color: "red", marginLeft:"60%",marginTop:"-15%" }}
                                    ></i> */}
                                </div>
                               
                            </>

                        })}<br />
             
                       


                    </div>
                  
                    <br/>
        <p className='text-center'>
          <button onClick={handleAdd} disabled={serviceList.length < 1} className='btn btn-primary btn-col'>Add</button>
        </p>
</div>


:
pageShow1 ?



<div className="formField">
{detailData.length>0 ?
    Object.values(doctors).map((doctor, index) => {
        

        const latestMedicine = doctor.medicines.sort((a, b) => new Date(b.date) - new Date(a.date))[0];
        const latestDate = latestMedicine ? latestMedicine.date : "";

        return(

            <div key={index} >
            <div className="checkbox-container">
          <input type="checkbox" style={{marginTop:"1%" ,marginLeft:"5%",width:"20px",height:"20px"}} checked={selectedItems.includes(index)} onChange={() => handleItemSelect(index)} />

        <div className='list-medicines' style={{ padding: "1px", marginTop: "20px", height: "auto", marginBottom:"2%", display: "flex" }}>
            <label style={{ color: "#000000", width: "30%", marginLeft: "2%" }} className='list-names'><h6 style={{fontSize: "17px" , width:"130%",color:"#585858"}}>{doctor.name}</h6> <h6 style={{fontSize: "10px",marginTop:"-2%" ,marginLeft:"-1%" }}> Last Prescribed on: {latestDate} </h6></label>
           
            <div style={{ width: "68%" }}>
                {doctor.medicines.map((medicine, i) => (
                    <div key={i} style={{ display: "flex", marginBottom: "5px" }}>
                        <div style={{ width: "35%",marginLeft:"10%" }}>
                            <h6 style={{ marginBottom: 0 }}><i class="fa fa-circle" style={{color:" #086073"}} aria-hidden="true"></i> <span></span><b> {medicine.schedule_name}</b></h6>
                           
                        </div>
                        <div style={{ width: "45%" }}>
                        <h6 style={{ marginBottom: 0 }}> <b>{medicine.amount === null ? "" : <>&#x20b9; {medicine.amount}</>}</b></h6>

                        </div>
                        <div style={{ width: "25%" }}>
                            <h6 style={{ marginBottom: 0 }}>
                                {medicine.hosp_service_id === null ? (
                                    <i class="fa fa-times-circle" aria-hidden="true" style={{ color: "red" }}></i>
                                ) : (
                                    <i class="fa fa-check-square" aria-hidden="true" style={{ color: "green" }}></i>
                                )}
                            </h6>
                            {/* <i
    class="fas fa-trash-alt"
    onClick={() => handleRemoveItem(index)}
    style={{ float: "right", color: "red", marginLeft: "50%", marginTop: "-5%" }}
></i> */}
                        </div>


                    </div>
    ))}
            </div>
        </div>
</div></div>)}) :
    <h4 className="text-center" style={{ color: "red" }}>No Prescriptions !!</h4>
}


<br/>
        <p className='text-center'>
          <button onClick={handleMed}  disabled={selectedItems.length < 1 } className='btn btn-primary btn-col'>Add</button>
        </p>


</div>





:""}





</div>

)


}

export default MedicinePage